import { useContext } from "react";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import {
  generateLocationMeta,
  generateMagazineClassfications,
  generateMagazineTemplate,
} from "./transformer";
import MagazinePaper from "./components/MagainzePaper";
import MagazineConfig from "./config";
import DocumentGeneratorCTX from "../document-generator/context";
import { isNumber } from "lodash";

const MonthlyMagazine = ({ dataset }) => {
  const Config = useContext(MagazineConfig);
  const { pagesStartFrom, selectedYear, selectedMonth } =
    useContext(DocumentGeneratorCTX);
  const [magazineTemplate, setMagazineTemplate] = useState(undefined);
  const [pageCollection, setPageCollection] = useState([]);
  const [locationMeta, setLocationMeta] = useState({});

  const sanitizedPageStartFrom =
    typeof pagesStartFrom === "string"
      ? parseInt(pagesStartFrom)
      : isNumber(pagesStartFrom)
      ? pagesStartFrom
      : 0;

  useEffect(() => {
    if (Object.keys(locationMeta).length !== 0) {
      return;
    }
    const generatedMeta = generateLocationMeta({ dataset });
    setLocationMeta(generatedMeta);
  }, [locationMeta, dataset]);

  useEffect(() => {
    if (Object.keys(locationMeta).length === 0) {
      return;
    }
    try {
      const generatorDataMap = generateMagazineClassfications({ dataset });
      const template = generateMagazineTemplate({
        generatorMap: generatorDataMap,
        rows: Config.NO_OF_AD_ROWS_PER_PAGE,
        columns: Config.NO_OF_AD_COLUMNS_PER_PAGE,
        genderPriority: Config.GENDER_PRIORITY,
        regionPriority: Config.REGION_PRIORITY,
        locationMeta,
      });
      setMagazineTemplate(template);
    } catch (error) {
      console.log("Error! MonthlyMagazine Component ", error);
    }
  }, [
    dataset,
    Config.NO_OF_AD_ROWS_PER_PAGE,
    Config.NO_OF_AD_COLUMNS_PER_PAGE,
    Config.GENDER_PRIORITY,
    Config.REGION_PRIORITY,
    locationMeta,
  ]);

  useEffect(() => {
    if (magazineTemplate === undefined) {
      return;
    }
    const pageCollection = [];
    const adsPerPage =
      Config.NO_OF_AD_COLUMNS_PER_PAGE * Config.NO_OF_AD_ROWS_PER_PAGE;

    Object.keys(magazineTemplate).forEach((gender) => {
      const categoryAds = magazineTemplate[gender];
      if (!Array.isArray(categoryAds)) {
        return;
      }

      // constructing page meta
      for (let current = 0; current < categoryAds.length; current++) {
        let pageAds = categoryAds[current];
        const isLastPage = current + 1 === categoryAds.length;

        if (isLastPage && pageAds.length !== adsPerPage) {
          const difference = Math.abs(adsPerPage - pageAds.length);
          const tempArray = Array.from(Array(difference).fill(undefined));
          pageAds = [...pageAds, ...tempArray];
        }

        const pageMeta = {
          advertisments: pageAds,
          pageNumber: sanitizedPageStartFrom + current,
          header: {
            leftContent: `${selectedMonth} | ${selectedYear}`,
            rightContent: Config.HEADER.GENDER_LABEL[gender],
          },
          title: current === 0 ? Config.HEADER.GENDER_LABEL[gender] : undefined,
        };
        pageCollection.push(pageMeta);
      }
      // transform state - correction to page numbers
      for (let current = 0; current < pageCollection.length; current++) {
        const pageMeta = pageCollection[current];
        pageMeta.pageNumber = sanitizedPageStartFrom + current;
      }

      setPageCollection(pageCollection);
    });
  }, [
    Config.HEADER.GENDER_LABEL,
    Config.HEADER.MONTH_LABEL,
    Config.NO_OF_AD_COLUMNS_PER_PAGE,
    Config.NO_OF_AD_ROWS_PER_PAGE,
    magazineTemplate,
    sanitizedPageStartFrom,
    selectedMonth,
    selectedYear,
  ]);

  return (
    <Grid container direction="column">
      {pageCollection.map((pageMeta, index) => (
        <MagazinePaper
          key={index}
          advertisments={pageMeta.advertisments}
          pageNumber={pageMeta.pageNumber}
          header={pageMeta.header}
          title={pageMeta.title}
        />
      ))}
    </Grid>
  );
};

export default MonthlyMagazine;
